import React from 'react';
import { CTAButton } from './CTAButton';
export const CTASection = () => {
  return <section className="w-full bg-blue-50 py-10 px-4" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-29">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-30">
            Message d'Urgence Personnelle
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-31">
            Votre engourdissement ne va pas s'améliorer tout seul. Chaque nuit
            qui passe, vous perdez un peu plus de sensation. Pour le prix d'un
            souper au restaurant, vous pourriez changer votre vie.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-32">
            Ne laissez pas l'orgueil ou la peur vous empêcher d'essayer. Dans 30
            jours, vous saurez si ça marche pour vous. Et si ça ne marche pas ?
            Vous aurez simplement éliminé une option.
          </p>
          <div className="bg-blue-50 p-4 rounded-lg mb-6" data-id="element-33">
            <p className="text-gray-700 italic" data-id="element-34">Dr. Martineau conclut :</p>
            <p className="text-gray-700 italic font-bold" data-id="element-35">
              "Dans 30 jours, vous serez dans l'un de ces deux cas : soit vous
              regrettez de ne pas avoir essayé KinéPulse, soit vous nous
              remerciez de vous avoir redonné l'espoir."
            </p>
          </div>
          <CTAButton showPrice={true} data-id="element-36" />
          <p className="text-center text-gray-600 mt-4" data-id="element-37">
            Questions ? support@nevara-quebec.com
          </p>
          <p className="text-center text-blue-600 font-bold mt-2" data-id="element-38">
            "Cliquez maintenant. Vos pieds méritent ces 30 jours d'espoir."
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-39">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-40">
            Post-Scriptum Important
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-41">
            <span className="font-bold" data-id="element-42">P.S.</span> - Rappelez-vous Marcel du
            début de cet article. Il me dit souvent : "Si j'avais su qu'un
            appareil à 114.99$ existait, j'aurais économisé mes trois orteils."
            Ne soyez pas Marcel. Essayez maintenant.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-43">
            <span className="font-bold" data-id="element-44">P.P.S.</span> - 30 jours passent vite.
            Vos nerfs ne peuvent pas attendre. Commandez aujourd'hui.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-45">
            <span className="font-bold" data-id="element-46">P.P.P.S.</span> - Si vous lisez encore
            ces lignes, c'est que vous hésitez. L'hésitation, c'est exactement
            ce qui a coûté ses orteils à Marcel. Ne laissez pas la peur de
            l'espoir vous paralyser.
          </p>
          <div className="bg-green-600 text-white p-6 rounded-lg text-center mb-6" data-id="element-47">
            <h3 className="text-xl font-bold mb-2" data-id="element-48">
              Commandez Votre KinéPulse Maintenant
            </h3>
            <p className="text-lg mb-4" data-id="element-49">114.99$ - Prix de Lancement Exclusif</p>
            <a href="https://nevaraquebec.com/products/kinepulse-masseur-4-en-1-qui-soulage-les-douleurs-neuropathiques" target="_blank" rel="noopener noreferrer" className="block bg-yellow-400 text-gray-800 font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500 transition duration-300 text-lg w-full text-center" data-id="element-50">
              COMMANDE IMMÉDIATE - STOCK LIMITÉ
            </a>
          </div>
          <div className="flex flex-wrap justify-center gap-4 text-center" data-id="element-51">
            <div className="flex items-center" data-id="element-52">
              <div className="h-5 w-5 rounded-full bg-blue-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-53">
                ✓
              </div>
              <p className="text-gray-700 text-sm" data-id="element-54">Livraison Express Canada</p>
            </div>
            <div className="flex items-center" data-id="element-55">
              <div className="h-5 w-5 rounded-full bg-blue-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-56">
                ✓
              </div>
              <p className="text-gray-700 text-sm" data-id="element-57">Paiement 100% Sécurisé</p>
            </div>
            <div className="flex items-center" data-id="element-58">
              <div className="h-5 w-5 rounded-full bg-blue-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-59">
                ✓
              </div>
              <p className="text-gray-700 text-sm" data-id="element-60">
                Support Client en Français
              </p>
            </div>
            <div className="flex items-center" data-id="element-61">
              <div className="h-5 w-5 rounded-full bg-blue-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-62">
                ✓
              </div>
              <p className="text-gray-700 text-sm" data-id="element-63">
                Garantie 30 Jours Satisfait ou Remboursé
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};